import Paragraph from "@components/Article/Paragraph";
const View = ({ ...item }) => {
  return <Paragraph {...item} />;
};

View.strapiName = "story.paragraph";

export default View;
